//ecd:1992639969H20261022084009_V3.0
import { request, requestOrNull, seg, Page } from './apiSupport';
import { PurchaseOrderDTO } from './PurchaseOrderDTO';
import { PurchaseOrderKeyDTO } from './PurchaseOrderKeyDTO';
import { PurchaseOrderSrchDTO } from './PurchaseOrderSrchDTO';
import { OrderStatus } from './OrderStatus';

/**
 * REST client for PurchaseOrder.
 *
 * Calls the endpoints PurchaseOrderController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/purchaseOrder';

/** Registers a new PurchaseOrder. */
export async function create(input: PurchaseOrderDTO): Promise<PurchaseOrderDTO> {
    return request<PurchaseOrderDTO>('POST', BASE, input);
}

/** The PurchaseOrder with this identifier, or null when there is none. */
export async function findById(orderId: string): Promise<PurchaseOrderDTO | null> {
    return requestOrNull<PurchaseOrderDTO>('GET', BASE + '/' + seg(orderId));
}

/** Every PurchaseOrder matching the condition. */
export async function search(condition: PurchaseOrderSrchDTO): Promise<Page<PurchaseOrderDTO>> {
    return request<Page<PurchaseOrderDTO>>('POST', BASE + '/search', condition);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: PurchaseOrderKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the PurchaseOrder with this identifier. */
export async function deleteById(orderId: string): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(orderId));
}

/** Whether ship may be given now: the status is PLACED. */
export function canShip(value: PurchaseOrderDTO | null | undefined): boolean {
    return value != null && (value.status === OrderStatus.PLACED);
}

/** Whether cancel may be given now: the status is PLACED. */
export function canCancel(value: PurchaseOrderDTO | null | undefined): boolean {
    return value != null && (value.status === OrderStatus.PLACED);
}

/** Whether it may be deleted now: the status is CANCELLED. */
export function canDelete(value: PurchaseOrderDTO | null | undefined): boolean {
    return value != null && (value.status === OrderStatus.CANCELLED);
}

/** The ship command: PurchaseOrder decides, and answers with what it became. */
export async function ship(orderId: string): Promise<PurchaseOrderDTO> {
    return request<PurchaseOrderDTO>('POST', BASE + '/' + seg(orderId) + '/ship');
}

/** The cancel command: PurchaseOrder decides, and answers with what it became. */
export async function cancel(orderId: string): Promise<PurchaseOrderDTO> {
    return request<PurchaseOrderDTO>('POST', BASE + '/' + seg(orderId) + '/cancel');
}

